export const config = {
    configuration: true,
    searchList: {
        searchTxt: [],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        selectBtn: true,
        leftOperation: false,
        height: 400,
        columns: [
            {
                label: '大箱条码',
                prop: 'boxBarcodeNo'
            },
            {
                label: '小箱条码',
                prop: 'barcodeNo'
            },
            {
                label: '数量',
                prop: 'count'
            },
            {
                label: '产品编码',
                prop: 'itemCode'
            },
            {
                label: '产品名称',
                prop: 'itemName'
            },
            {
                label: '生产日期',
                prop: 'prodDate'
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};